import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Tiro_Devanagari_Hindi%22,%22arguments%22:[{%22subsets%22:[%22devanagari%22],%22weight%22:%22400%22,%22preload%22:false}],%22variableName%22:%22devanagari%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Tiro Devanagari Hindi', 'Tiro Devanagari Hindi Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
